var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('li',{on:{"click":function($event){return _vm.toDetail(item)}}},[_c('div',{staticClass:"list-title"},[_c('h3',[_vm._v(_vm._s(item.title))])]),_c('div',{staticClass:"list-desc"},[_vm._v(" "+_vm._s(item.introduction)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }